import { buildCssWithOpacity } from "./buildCssWithOpacity";

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 2% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity2`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity2 = buildCssWithOpacity(0.02);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 3% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity3`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity3 = buildCssWithOpacity(0.03);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 5% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity5`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity5 = buildCssWithOpacity(0.05);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 10% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity10`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity10 = buildCssWithOpacity(0.1);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 15% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity15`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity15 = buildCssWithOpacity(0.15);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 20% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity20`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity20 = buildCssWithOpacity(0.2);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 25% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity25`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity25 = buildCssWithOpacity(0.25);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 30% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity30`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity30 = buildCssWithOpacity(0.3);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 35% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity35`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity35 = buildCssWithOpacity(0.35);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 40% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity40`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity40 = buildCssWithOpacity(0.4);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 45% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity45`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity45 = buildCssWithOpacity(0.45);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 50% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity50`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity50 = buildCssWithOpacity(0.5);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 55% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity55`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity55 = buildCssWithOpacity(0.55);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 60% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity60`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity60 = buildCssWithOpacity(0.6);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 65% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity65`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity65 = buildCssWithOpacity(0.65);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 70% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity70`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity70 = buildCssWithOpacity(0.7);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 75% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity75`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity75 = buildCssWithOpacity(0.75);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 80% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity80`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity80 = buildCssWithOpacity(0.8);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 85% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity85`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity85 = buildCssWithOpacity(0.85);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 90% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity90`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity90 = buildCssWithOpacity(0.9);

/**
 * A tagged template which accepts a TS token name and returns CSS where any style referencing the token has 95% opacity applied via
 *   relative css colors (90%+ browser support), with a fallback where opacity is added by transforming underlying token value
 *   (for <10% browser support).
 *
 * @example
 * ```
 * const MyDiv = styled.div`
 *   ${cssWithOpacity95`background-color: ${"Action.surface.default"}`};
 * `;
 * ```
 */
export const cssWithOpacity95 = buildCssWithOpacity(0.95);
